export const params = {
  viewBoxMobile: {
    start: [774, -262, 874, 1877],
    end: [774, 150, 874, 362],
  },
  viewBoxDesktop: {
    start: [0, 0, 2500, 929],
    end: [0, 221, 2500, 227],
  },
  markers: [
    {
      text: 'USA',
      id: 'usa',
      params: {
        mobile: {
          text: [-9, 95.47],
          marker: [28.5, 90.4452],
          line: 'M322.059 83.0349L27.4217 91.04',
        },
        desktop: {
          text: [813, 391.18],
          marker: [859.5, 384.445],
          line: 'M1486.71 400.217L860 384.5',
        },
      },
    },
    {
      text: 'FN',
      id: 'fn',
      params: {
        mobile: {
          text: [14, 75.47],
          marker: [43.4941, 70.2017],
          line: 'M322.714 83.5343L43.2145 69.9828',
        },
        desktop: {
          text: [895, 368.18],
          marker: [938.5, 363.5],
          line: 'M1488.5 401.5L935.976 364.499',
        },
      },
    },
    {
      text: 'RUSSLAND',
      id: 'russland',
      params: {
        mobile: {
          text: [286, 13.47],
          marker: [320.787, 23.0305],
          // line: 'M320.194 20.2832L322.06 82.6956',
          line: 'M322.06 82.6956L320.194 20.2832',
        },
        desktop: {
          text: [1496, 278.18],
          marker: [1482.56, 272.5],
          line: 'M1486.71 399.527L1482.91 272.598',
        },
      },
    },
    {
      text: 'NORGE',
      id: 'norge',
      params: {
        mobile: {
          text: [195, 13.47],
          marker: [256.897, 8.27905],
          line: 'M322.399 83.035L255.577 6.46704',
        },
        desktop: {
          text: [1273, 247.18],
          marker: [1348.56, 242.5],
          line: 'M1487.4 400.217L1351.5 244.5',
        },
      },
    },
    {
      text: 'EU',
      id: 'eu',
      params: {
        mobile: {
          text: [216, 38.47],
          marker: [246.135, 32.8647],
          line: 'M322.399 83.0347L244.513 30.561',
        },
        desktop: {
          text: [1290, 298.18],
          marker: [1326.56, 292.5],
          line: 'M1487.4 400.216L1329 293.5',
        },
      },
    },
    {
      text: 'GAZA',
      id: 'gaza',
      params: {
        mobile: {
          text: [331, 89.47],
          marker: [322.555, 83.5],
        },
        desktop: {
          text: [1499.12, 408.498],
          marker: [1488.81, 401.578],
        },
      },
    },
  ],
}
